import DeletePopup from "../../Modals/DeletePopup";
import EmptyData from "../../components/EmptyData";
import { useNavigate } from "react-router-dom";
import useGrading from "./hooks/useGrading";

const { REACT_APP_IMAGE_URL } = process.env;

const CardGrading = () => {
  const navigate = useNavigate();
  const {
    services,
    loading,
    open,

    setOpen,
    handleToggleStatus,
    handleDeleteService,
    handleDeletePopup,
  } = useGrading();

  return (
    <div className="container">
      <div className="flex-md-row flex-column gap-2 d-flex justify-content-between align-items-center mb-3">
        <h3 className="fw-600 col-md-6">
          Grading Services ({services?.length || 0})
        </h3>
        <div className="d-flex align-items-center justify-content-between"></div>
        <button
          className="mt-2 btn common-button"
          onClick={() => navigate("/grading/add")}
        >
          + Add New Grading Service
        </button>
      </div>

      <div className="table-responsive">
        <table className="table align-middle">
          <thead>
            <tr>
              <th>Image</th>
              <th>Name</th>
              <th>Description</th>
              <th>Price ($)</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="6" className="text-center py-4">
                  Loading...
                </td>
              </tr>
            ) : services?.length > 0 ? (
              services.map((item) => {
                const id = item?.id || item?._id;
                const isActive = Boolean(item?.is_active);
                return (
                  <tr key={id}>
                    <td>
                      {item?.images?.[0] ? (
                        <img
                          src={`${REACT_APP_IMAGE_URL}${item.images[0]}`}
                          alt={item?.name}
                          style={{
                            width: 48,
                            height: 48,
                            objectFit: "cover",
                            borderRadius: 6,
                          }}
                        />
                      ) : (
                        "-"
                      )}
                    </td>
                    <td>{item?.name}</td>
                    <td className="text-truncate" style={{ maxWidth: 260 }}>
                      {item?.description}
                    </td>
                    <td>
                      {item?.price_per_card
                        ? `$ ${Math.round(item?.price_per_card)}`
                        : "-"}
                    </td>
                    <td>
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input cursor-pointer"
                          type="checkbox"
                          role="switch"
                          checked={isActive}
                          onChange={() => handleToggleStatus(item)}
                          title={isActive ? "Active" : "Inactive"}
                        />
                      </div>
                    </td>
                    <td>
                      <div className="d-flex gap-2">
                        <button
                          className="btn btn-sm btn-outline-secondary"
                          title="Edit"
                          onClick={() => navigate(`/grading/edit/${id}`)}
                        >
                          <i className="bi bi-pencil" />
                        </button>
                        <button
                          className="btn btn-sm btn-outline-danger "
                          title="Delete"
                          onClick={() => handleDeletePopup(id)}
                        >
                          <i className="bi bi-trash3" />
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <EmptyData />
            )}
          </tbody>
        </table>
      </div>

      {open && (
        <DeletePopup
          open={open}
          setOpen={setOpen}
          handleDelete={handleDeleteService}
          label="Are you sure, you want to delete this Grading Service"
        />
      )}
    </div>
  );
};

export default CardGrading;
